var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-mission-statement"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('activerecord.attributes.company.mission_statement')))]), _vm._v(" "), _c('autosize-textarea', {
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-mission-statement",
      "rows": "3"
    },
    model: {
      value: (_vm.company.mission_statement),
      callback: function($$v) {
        _vm.company.mission_statement = $$v
      },
      expression: "company.mission_statement"
    }
  })], 1), _vm._v(" "), (_vm.company.mission_statement) ? _c('p', {
    staticClass: "mission-statement"
  }, [_vm._v(_vm._s(_vm.company.mission_statement))]) : (_vm.editable) ? _c('p', {
    staticClass: "mission-statement mission-statement--empty"
  }, [_vm._v(_vm._s(_vm.I18n.t('add_a_mission_statement')))]) : _vm._e()], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b5854a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/mission-statement.vue
// module id = null
// module chunks = 